import { Icon } from '@iconify/react'
import AppEvent from '../../model/Event'
import styles from './EventCard.module.css'

export interface EventCardProps {
  event: AppEvent
  eventIcon?: string
  hasRSVPd: boolean
  isPending: boolean
  onAction: () => void
}

export default function EventCard({
  event,
  eventIcon,
  hasRSVPd,
  isPending,
  onAction,
}: EventCardProps) {
  const buttonStyle = {
    backgroundColor: hasRSVPd
      ? 'var(--green)'
      : event.buttonColorHex || 'var(--brand-primary, var(--orange))',
  }

  return (
    <div className={styles.card}>
      {eventIcon && <img src={eventIcon} alt={event.name} className={styles.image} />}
      <button
        type="button"
        className={styles.action}
        style={buttonStyle}
        onClick={onAction}
        disabled={isPending || hasRSVPd}
      >
        {hasRSVPd && <Icon icon="mdi:check" width={16} />}
        {hasRSVPd ? "RSVP'd" : event.buttonText}
      </button>
    </div>
  )
}
